import {Component, HostListener, Injector} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {DetailComponent} from '../shared/detail/detail.component';
import {DialogService} from '../shared/dialog/dialog.service';
import {MasterDetailActionSource, MasterDetailHub} from '../shared/master-detail/master-detail-hub.service';
import {ShowType, SnackMessage} from "../shared/dialog/snack-bar/snack-bar/snack-bar.component";
import {ValidationService} from "../shared/cml-forms/validation.service";
import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {Field} from "../shared/detail/detail.service";


@Component({
    selector: 'cml-uctovy-rozvrh-detail',
    templateUrl: '../shared/detail/detail.component.html',
    styleUrls: ['../shared/detail/detail.component.scss'],
    standalone: false
})
export class UctovyRozvrhDetailComponent extends DetailComponent
{
  constructor(router: Router, route: ActivatedRoute, injector: Injector, dialogService: DialogService, masterDetailHub: MasterDetailHub, private dialog: MatDialog,
              validationService: ValidationService,) {
    super(router, route, injector, dialogService, masterDetailHub, validationService);
  }

  @HostListener('window:keydown.escape', ['$event']) onKeyDownHandler(event: KeyboardEvent)
  {
    if (!(this.dialog.openDialogs.length > 0)) {
      this.detailService.close();
    }
  }


  override async initialiseState() {
    this.initialLoading = true;
    if (this.isNew) {
      this.entity = new Object();
    }
    else if (this.entityId) {
      this.entity = await this.detailService.get({"kodUj": this.entityId, "kodUo": this.route.pathFromRoot[3].snapshot.params["kod"], "su": this.route.snapshot.params["su"], "au": this.route.snapshot.params["au"]});
    }
    this.form = this.createForm(this.fields);
    this.detailService.init();
    this.buttons = this.detailService.createToolbarButtons();
    this.initialLoading = false;
  }

  override async deleteEntity() {
    const conf = await this.dialogService.confirm({title: "Potvrzení", detail: "Chcete opravdu smazat tuto dokladovou řadu?"});

    if (!conf) return;

    await this.detailService.delete({"kodUj": this.entityId, "kodUo": this.route.pathFromRoot[3].snapshot.params["kod"], "su": this.route.snapshot.params["su"], "au": this.route.snapshot.params["au"]});
    this.detailService.close();
    this.masterDetailHub.emitRefresh(MasterDetailActionSource.detail);
  }

  override async save() {
    if (this.form.valid) {
      try {
        this.fillEntityFromForm();
        if (this.isNew) {
          const kodUj = this.route.pathFromRoot[3].snapshot.params["id"];
          const kodUo = this.route.pathFromRoot[3].snapshot.params["kod"];
          const result = await this.detailService.create({"kodUj": kodUj, "kodUo": kodUo}, this.entity);
          this.router.navigate([this.basePath, 'edit', kodUj, 'uctovy-rozvrh', kodUo, 'edit', result["su"], result["au"]]);
        } else {
          const result = await this.detailService.edit(this.entityId, this.entity);
          this.entity = result;
          this.form = this.createForm(this.fields);
        }
        this.masterDetailHub.emitRefresh(MasterDetailActionSource.detail);
      } catch (e) {
        await this.dialogService.handleError(e)
        this.detailService.baseCrudService.api.isBusy$.next(false);
      }
    } else {
      let errors = this.getFormValidationErrors();
      if (errors.length > 0) {
        await this.dialogService.alert({title: "Validace", detail: errors.join('<br><br>')});
      }
    }
  }

  override async reload(): Promise<void> {
    this.entity = this.entity = await this.detailService.get({"kodUj": this.entityId, "kodUo": this.route.pathFromRoot[3].snapshot.params["kod"], "su": this.route.snapshot.params["su"], "au": this.route.snapshot.params["au"]});
    this.form = this.createForm(this.fields);
  }
}
